(function() {
  var config = {
    dbkey: 'nfjDzjWHyRMAAAAAAAB1wwGS7NxTO-t--e-goHLDz1ehGLBbAmf-0GsjyRcfPs7_', // live
    //dbkey: '6_LM46ZbijkAAAAAAAAC211yWqWk1WuRZWr3-F-0zDhQUzcAoSKQ_cpxlMw3LSaQ', // testing
    path:  'registration/' // default: ''
  };

  $(function() {
    var files = [];

    $('#contact_form input[type="submit"]').prop('disabled', ($('#contactFormEmail').val().length === 0));
    $('#contactFormEmail').on('keyup keydown change', function() {
      $('#contact_form input[type="submit"').prop('disabled', ($(this).val().length === 0));
    });
    $('#contact_form').on('submit', function(e) {
      if ($('#contactFormEmail').val().length === 0) {
        e.preventDefault();
      }
    });


    $('#attach-upload').on('change', function(e) {
      files = jQuery.merge(files, e.target.files); // FileList object(s)

      jQuery('#attach-files-list').html('');
      for (var i = 0, f; f = files[i]; i++) {
        jQuery('#attach-files-list').append(
          jQuery('<li></li>').text(f.name).prepend(
            jQuery('<span></span>').html('&times;').addClass('cancel-upload').attr('data-file-upload-position', i)
          )
        );
      }

      jQuery('form#contact_form').attr('data-uploads-pending', true).on('submit', function(e) {
        if (jQuery(this).is('[data-uploads-pending]')) {
          e.preventDefault();
          uploadBeforeSubmit();
        }
      });
    });


    $('#attach-files-list').on('click', '.cancel-upload', function() {
      $(this).parent().remove();
      var pos = $(this).attr('data-file-upload-position');
      var newFiles = [];
      for (var i = 0, f; f = files[i]; i++) {
        if (i != pos) {
          newFiles.push(f);
        }
      }
      files = newFiles;
      $('#attach-upload').val("");
    });


    function uploadBeforeSubmit() {
      $('#contact_form input[type="submit"]').prop('disabled', true);
      // Build the short date string
      var dateobj = new Date();
      var month = dateobj.getMonth()+1;
      if (month < 10) { month = '0'+month; }
      var dayOfMonth = dateobj.getDate();
      if (dayOfMonth < 10) { dayOfMonth = '0'+dayOfMonth; }
      var datestr = dateobj.getFullYear()+'-'+month+'-'+dayOfMonth;

      // files is a FileList of File objects
      fileCount = files.length;
      uploadedCount = 0;
      for (var i = 0, f; f = files[i]; i++) {
        (function() {
          var onUploadSuccess;
          if (i == 0) {
            onUploadSuccess = function(data) {
              var sharePath = data.path_display.replace(/\/[^\/]+$/, '');
              $.ajax(
                {
                  url: 'https://api.dropboxapi.com/2/sharing/list_shared_links',
                  type: 'post',
                  data: '{"path": "' + sharePath + '"}',
                  processData: false,
                  contentType: 'application/json',
                  headers: {
                    "Authorization": "Bearer " + config.dbkey
                  },
                  success: function(sharedata) {
                    if (sharedata.links.length > 0) {
                      $('#attach-dropbox-url').prop('disabled', false).val(sharedata.links[0].url);
                      uploadedCount++;
                      if (uploadedCount==fileCount) {
                        jQuery('form#contact_form').removeAttr('data-uploads-pending').submit();
                      }
                    } else {
                      $.ajax(
                        {
                          url: 'https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings',
                          type: 'post',
                          data: '{"path": "' + sharePath + '"}',
                          processData: false,
                          contentType: 'application/json',
                          headers: {
                            "Authorization": "Bearer " + config.dbkey
                          },
                          success: function(newsharedata) {
                            $('#attach-dropbox-url').prop('disabled', false).val(newsharedata.url);
                            uploadedCount++;
                            if (uploadedCount==fileCount) {
                              jQuery('form#contact_form').removeAttr('data-uploads-pending').submit();
                            }
                          }
                        }
                      );
                    }
                  }
                }
              );
            };
          } else {
            onUploadSuccess = function(data) {
              uploadedCount++;
              if (uploadedCount==fileCount) {
                jQuery('form#contact_form').removeAttr('data-uploads-pending').submit();
              }
            };
          }

          $.ajax(
            {
              url: 'https://content.dropboxapi.com/2/files/upload',
              type: 'post',
              data: f,
              processData: false,
              contentType: 'application/octet-stream',
              headers: {
                "Authorization": "Bearer " + config.dbkey,
                "Dropbox-API-Arg": '{"path": "/' + config.path + datestr + '/' + $('#contactFormEmail').val() + '/' + $('#email').val() + ' - ' + f.name + '", "autorename": true, "mode": "add"}'
              },
              success: function(data) {
                onUploadSuccess(data);
              }
            }
          );
        })();
      }
    }
  });
})();
